/** Default zoom level for all map initialization */
export const MAP_ZOOM_DEFAULT = 10;

/** Minimum zoom level when re-centering on a location */
export const MAP_ZOOM_MIN_RECENTER = 9;

/** Fallback zoom when getZoom() returns undefined */
export const MAP_ZOOM_FALLBACK = 5;

/** Center of the continental US, used when no location is available */
export const US_CENTER = { lat: 39.8283, lng: -98.5795 } as const;
